import { VALUE_DIFFERENCE_DISPLAY } from 'components/View/constants';

import { formatPrice } from '../../../utils/helpers/numbers';
import { getFilename } from '../GraphWidget/utils';
import { calculateValueDifference } from '../valueDifferenceUtils';

const isEmptyValue = (value: unknown) => value === null || value === undefined || value === '';

export const formatText = (value: string | null | undefined) => (isEmptyValue(value) ? '-' : value);

export const formatCurrency = (value: number | null | undefined) => {
  if (isEmptyValue(value)) {
    return '-';
  }

  return formatPrice(Number(value), '$', 0, 0);
};

export const formatRoomTypeHeader = (roomType: string) => (roomType ? roomType.toUpperCase() : '-');

export const getDisplayDifference = (
  baseValue: number | null | undefined,
  difference: number | null | undefined,
  valueDisplay?: number
) => {
  if (difference === null || difference === undefined) {
    return null;
  }

  if (valueDisplay === VALUE_DIFFERENCE_DISPLAY.PERCENTAGES) {
    if (baseValue === null || baseValue === undefined) {
      return null;
    }
    const targetValue = baseValue - difference;
    return calculateValueDifference(targetValue, baseValue, VALUE_DIFFERENCE_DISPLAY.PERCENTAGES);
  }

  return difference;
};

export const getPricingComparisonFilename = (communityName: string, widgetName: string, comparisonLabel?: string) => {
  if (!comparisonLabel) {
    return getFilename(communityName, widgetName);
  }

  const adjustedCommunityName = communityName?.split(' ').join('_');
  const adjustedComparisonLabel = comparisonLabel?.split(' ').join('_');
  const adjustedWidgetName = widgetName?.split(' ').join('_');

  return getFilename(`${adjustedCommunityName}_${adjustedComparisonLabel}`, adjustedWidgetName);
};
